import { Icons } from "app/constants/icons";
import { PAGES } from "app/constants/pages";
import { Button } from "app/shared/buttons/Button";
import { Link } from "app/shared/buttons/Link";

interface ErrorBoundaryProps {
  error?: Error | null;
  reset?: () => void;
}
const Body = (
  <>
    You&apos;re boldly gone where no
    <br /> man has gone before...
  </>
);
export const NotFound = ({error, reset}: ErrorBoundaryProps) => {
  return (
    <main className="flex h-screen w-screen flex-col items-center justify-center bg-[url('/background/error.webp')] bg-cover bg-center p-4">
      <div className="flex flex-col gap-3.75 text-center">
        <h1
          className={
            'mb-8 bg-gradient-to-r from-gray-400 via-white to-gray-400 bg-clip-text pb-2 text-center text-4xl font-medium leading-[66px] text-transparent  desktop:text-6xl tablet:text-4xl mobile:text-3xl'
          }>
          {!error ? '404 Page Not Found' : 'Unexpected error'}
        </h1>
        {}
        <p className="text-center text-xl font-light text-gray-100 light:text-neutral-500">
          {process.env.NODE_ENV === 'development'
            ? error?.message || Body
            : Body}
        </p>
      </div>
      {reset && error && (
        <Button
          variant="black-contained"
          size="lg"
          onClick={reset}
          className="mt-8 flex w-fit items-center justify-center gap-2 font-semibold">
          Try again
        </Button>
      )}
      {/*404 pages (not-found.tsx) dont have error props */}
      {!error && (
        <Link
          className="mt-8 flex w-fit items-center justify-center gap-2 font-semibold"
          variant="black-contained"
          size="lg"
          href={PAGES.HOME}>
          <span className="bg-gradient-to-r from-blue-500 to-black bg-clip-text text-transparent">
            Go back home
          </span>
          <Icons.refresh className="h-5 w-5" />
        </Link>
      )}
    </main>
  );
};
